import React from 'react'
export function MicroButtonIcon({ iconPath }: { readonly iconPath: string }) {
  return (
    <img
      alt={''}
      aria-hidden={'true'}
      className={'ml-[5px] shrink-0'}
      height={12}
      src={iconPath}
      width={12}
    />
  )
}
